import {Input, InputProps} from '@chakra-ui/react';
import React, {memo} from 'react';

interface Props extends InputProps {}

export const UiInput = memo(({...rest}: Props) => <Input {...rest} />);
